// OrganizationCard.jsx
import React from 'react';
import { useNavigate } from 'react-router-dom';
import './OrganizationCard.css';

const DEFAULT_AVATAR =
  '/nkarner/20260110_1932_Image Generation_remix_01kem8h20rewa81f8h55ncqmm9 (2).png';

const OrganizationCard = ({ organization }) => {
  const navigate = useNavigate();

  const handleCardClick = () => {
    navigate(`/profile/${organization.id || organization._id}`);
  };

  // ✅ Avatar URL with fallback
  const avatarSrc = organization.avatar && organization.avatar !== 'undefined'
    ? organization.avatar
    : DEFAULT_AVATAR;

  // ✅ Calculate posts count ACCURATELY
  const calculatePostsCount = () => {
    // 1. Եթե posts-ը array է, օգտագործել length
    if (Array.isArray(organization.posts)) {
      return organization.posts.length;
    }
    
    // 2. Եթե postsCount կամ totalPosts առկա է որպես number
    const numericCount = organization.postsCount || organization.totalPosts;
    if (typeof numericCount === 'number' && !isNaN(numericCount)) {
      return numericCount;
    }
    
    // 3. Եթե posts-ը object է, հաշվել key-երի քանակը
    if (organization.posts && typeof organization.posts === 'object') {
      return Object.keys(organization.posts).length;
    }
    
    // 4. Default fallback
    return 0;
  };

  const postsCount = calculatePostsCount();

  // ✅ Format large numbers (e.g., 1,234)
  const formatNumber = (num) => {
    return num.toLocaleString();
  };

  return (
    <div
      className="vop-organization-card"
      onClick={handleCardClick}
      style={{ cursor: 'pointer' }}
    >
      <div className="vop-card-header">
        <div className="vop-avatar-container">
          <img
            src={avatarSrc}
            alt={organization.name}
            className={`vop-organization-avatar vop-rank-${organization.rank || 1}`}
            onError={(e) => {
              e.target.onerror = null;
              e.target.src = DEFAULT_AVATAR;
            }}
          />

          <div className="vop-rank-badge">
            <span className="vop-rank-number">
              {organization.rank || 1}
            </span>
            <span className="vop-rank-text">rank</span>
          </div>
        </div>
      </div>

      <div className="vop-card-body">
        <h3 className="vop-organization-name">
          {organization.name}
          {organization.isVerified && (
            <span
              className="vop-verified-star"
              style={{ marginLeft: '8px', color: '#facc15', fontSize: '1rem' }}
            >
              ★
            </span>
          )}
        </h3>

        <p className="vop-organization-bio">
          {organization.shortBio || organization.description || 'No description available'}
        </p>

        <div className="vop-organization-stats">
          <div className="vop-stat">
            <span className="vop-stat-numbers">
              {formatNumber(postsCount)} {/* Այստեղ ցույց է տալիս փոստերի քանակը */}
            </span>
            <span className="vop-stat-labels">Posts</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default OrganizationCard;